// User Guide API Service
import { apiGet, apiPost } from '../services/apiClient';

/**
 * User Guide Service
 * Handles all user guide mapping related API calls
 */
export const userGuideService = {
  /**
   * Get all menu modules
   * GET /gateway/registration/api/signup/master-menu-modules
   */
  getMenuModules: async () => {
    try {
      const response = await apiGet('/gateway/registration/api/signup/master-menu-modules');
      return response;
    } catch (error) {
      console.error('Error fetching menu modules:', error);
      throw error;
    }
  },

  /**
   * Get screens by module ID
   * GET /gateway/registration/api/signup/master-menu-modules/{moduleId}/screens
   */
  getScreensByModuleId: async (moduleId) => {
    try {
      const response = await apiGet(`/gateway/registration/api/signup/master-menu-modules/${moduleId}/screens`);
      return response;
    } catch (error) {
      console.error('Error fetching screens:', error);
      throw error;
    }
  },

  /**
   * Get all user guide mappings
   * GET /gateway/registration/api/signup/user-guide-mapping/list
   */
  getUserGuideMappings: async () => {
    try {
      const response = await apiGet('/gateway/registration/api/signup/user-guide-mapping/list');
      return response;
    } catch (error) {
      console.error('Error fetching user guide mappings:', error);
      throw error;
    }
  },

  /**
   * Lightweight list without html_content (table view).
   * GET /gateway/registration/api/signup/user-guide-mapping/list/summary
   */
  getUserGuideMappingsSummary: async () => {
    try {
      const response = await apiGet('/gateway/registration/api/signup/user-guide-mapping/list/summary');
      return response;
    } catch (error) {
      console.error('Error fetching user guide mapping summaries:', error);
      throw error;
    }
  },

  /**
   * Full mapping by id (includes html_content) for edit/view.
   * GET /gateway/registration/api/signup/user-guide-mapping/{id}
   */
  getUserGuideMappingById: async (id) => {
    try {
      const response = await apiGet(`/gateway/registration/api/signup/user-guide-mapping/${id}`);
      return response;
    } catch (error) {
      console.error('Error fetching user guide mapping by id:', error);
      throw error;
    }
  },

  /**
   * Save or update user guide mapping
   * POST /gateway/registration/api/signup/user-guide-mapping/saveOrUpdate
   */
  saveUserGuideMapping: async (data) => {
    try {
      const response = await apiPost('/gateway/registration/api/signup/user-guide-mapping/saveOrUpdate', data);
      return response;
    } catch (error) {
      console.error('Error saving user guide mapping:', error);
      throw error;
    }
  }
};

